// The score after the opening, and the score change across each stage the
// game reached: read with the review's own rules (`openingExit`,
// `phaseRange`), so the dashboard and the review agree about a game.
import { openingExit, readerPawns } from '@chess/api-review';
import { capPawns, type FactExtractor, type ScannedGame } from '../extractor.ts';
import { type GameFacts } from '@chess/api-model';
import { type Phase } from '@chess/api-model';

export const stageScores: FactExtractor = {
  id: 'stage-scores',
  extract(game: ScannedGame, facts: GameFacts): void {
    const swings: Partial<Record<Phase, number>> = {};
    const exit = openingExit(game.scan, game.phases, game.moves.length, game.reader);
    if (exit.score) {
      facts.openingScore = capPawns(readerPawns(exit.score));
      swings.opening = facts.openingScore;
    }
    for (const phase of ['middlegame', 'ending'] as const) {
      const { fromPly, toPly } = game.range(phase);
      if (toPly <= fromPly) continue;
      const start = game.pawnsAt(fromPly);
      const end = game.pawnsAt(toPly);
      if (start !== undefined && end !== undefined) swings[phase] = end - start;
    }
    facts.stageSwings = swings;
  },
};
